//
// Following are the all available pages for this site.
// They are listed in the NAVBAR ORDER and FOOTER ORDER
// NOTE: We are lazy loading the base React component.
// 
const routes: Route[] = [
  // Navbar      
  { path: "/",                    import: () => import("./pages/Home") },
  { path: "/about",               import: () => import("./pages/About") },
  { path: "/services",           import: () => import("./pages/Services") },
  { path: "/process",            import: () => import("./pages/Process") },
  { path: "/technology",         import: () => import("./pages/Technology") },
  { path: "/products",           import: () => import("./pages/Products") },
  { path: "/myaccount",          import: () => import("./pages/MyAccount") , module: "./pages/MyAccount"},
//  { path: "/authcallback",       import: () => import("./pages/AuthCallback") },

  // Footer 
  { path: "/privacy",             import: () => import("./pages/privacy.mdx") },
  { path: "/termsandconditions",  import: () => import("./pages/termsandconditions.mdx") },

  // Draft
  { path: "/blog",                import: () => import("./pages/blog/BlogHome") },
  { path: "/blog/:name",          import: () => import("./pages/blog/BlogTmpl") },

  { path: "*",                    import: () => import("./pages/FourOFour") },
];

export default routes;
